<script>
export const iconProps = {
    cssClasses: {
        default: 'h-6 w-6',
        type: String,
    },
    strokeWidth: {
        default: '1.5',
        type: [String, Number],
    },
}
</script>

<script setup>
defineProps(iconProps)
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :class="cssClasses"
        viewBox="0 0 24 24"
        :stroke-width="strokeWidth"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <slot />
    </svg>
</template>
